module.exports = __webpack_public_path__ + "img/w3_minimize_dark.0d550dc8.png";